import { z } from 'zod';
/** UUID v4 padrão. */
export const uuidSchema = z.string().uuid();
/** CUID2 (Prisma default). */
export const cuidSchema = z.string().min(20).max(30);
/** Email RFC-compliant + lowercase normalization. */
export const emailSchema = z
    .string()
    .trim()
    .toLowerCase()
    .email({ message: 'Email inválido.' });
/**
 * Número CNJ — formato NNNNNNN-DD.AAAA.J.TR.OOOO (20 dígitos numéricos + máscara).
 * Ex.: 0001234-56.2024.8.24.0038 → TJSC, foro 0038.
 *
 * Aceita com ou sem máscara. Validação de DV é feita em `packages/legal/src/cnj.ts`.
 */
export const cnjNumberSchema = z
    .string()
    .trim()
    .regex(/^\d{7}-?\d{2}\.?\d{4}\.?\d{1}\.?\d{2}\.?\d{4}$/, {
    message: 'Número CNJ inválido. Formato esperado: NNNNNNN-DD.AAAA.J.TR.OOOO (20 dígitos).',
});
/**
 * CPF — apenas dígitos ou com máscara. Validação completa de DV em `packages/legal/src/identity.ts`.
 */
export const cpfSchema = z
    .string()
    .trim()
    .regex(/^\d{3}\.?\d{3}\.?\d{3}-?\d{2}$/, { message: 'CPF inválido.' });
export const cnpjSchema = z
    .string()
    .trim()
    .regex(/^\d{2}\.?\d{3}\.?\d{3}\/?\d{4}-?\d{2}$/, { message: 'CNPJ inválido.' });
export const oabSchema = z
    .string()
    .trim()
    .toUpperCase()
    .regex(/^OAB\/[A-Z]{2}\s?\d{1,7}$/, {
    message: 'OAB inválida. Formato esperado: OAB/UF NNNNNNN.',
});
export const isoDateTimeSchema = z.string().datetime({ offset: true });
export const phoneE164Schema = z
    .string()
    .trim()
    .regex(/^\+[1-9]\d{1,14}$/, { message: 'Telefone deve estar em formato E.164 (+5547999999999).' });
/**
 * Senha de cofre interna (não para login — login é magic link).
 * Usada para descriptografar materiais sensíveis em momento de uso.
 */
export const vaultPassphraseSchema = z
    .string()
    .min(12, { message: 'Senha do cofre deve ter ao menos 12 caracteres.' })
    .max(256);
export const totpCodeSchema = z
    .string()
    .trim()
    .regex(/^\d{6}$/, { message: 'Código TOTP deve ter 6 dígitos.' });
export const recoveryCodeSchema = z
    .string()
    .trim()
    .regex(/^[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{4}$/, {
    message: 'Código de recuperação inválido.',
});
//# sourceMappingURL=primitives.js.map